// extracted by mini-css-extract-plugin
export default {"root":"styles_root__hIXU-","title":"styles_title__xWZaW","creating":"styles_creating__jDLZW"};